import React from "react";
import "./smartBanner.scss";
import { Facebook, Phone, Mail, Pin } from "../../../icons";

const SmartBanner: React.FC = () => {
  return (
    <div className="smartBanner">
      <div className="smartBanner__container">
        <div className="smartBanner__item">
          <Phone className="smartBanner__icon" />
          <a href="tel:530596229" className="smartBanner__text">
            530 596 229
          </a>
        </div>

        <div className="smartBanner__item smartBanner__item--email">
          <Mail className="smartBanner__icon" />
          <a
            href="mailto:studiowykonczeniowe@gmail.com"
            className="smartBanner__text smartBanner__text--normal"
          >
            studiowykonczeniowe@gmail.com
          </a>
        </div>
      </div>

      <div className="smartBanner__container smartBanner__container--right">
        <div className="smartBanner__item">
          <Pin className="smartBanner__icon" />
          <p className="smartBanner__text smartBanner__text--normal">
            Dębica i okolice do 100km
          </p>
        </div>

        <div className="smartBanner__item">
          <a
            href="https://www.facebook.com/profile.php?id=61565814942600"
            target="_blank"
            rel="noopener noreferrer"
            className="smartBanner__social-link"
            aria-label="Facebook"
          >
            <Facebook />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SmartBanner;
